// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2xeH9","modalFooterButton":"ModalNotes_modalFooterButton__3gDps"};